module.exports = __webpack_public_path__ + "static/media/bandit_armor.3396c4ab.png";